module.exports = __webpack_public_path__ + "img/quanguo.4bc80cf7.jpg";